/** @file English UI strings of the rig panels (E6): directions, skins, draw order, IK, events, sockets. */

export const rigPanelsEn = {
  rig: {
    noProject: 'Open a project to edit it here.', create: 'New', rename: 'Rename', delete: 'Delete', dismiss: 'Dismiss',
    keyHint: 'Open an animation in Animate mode to key this.', keying: 'Keying at frame {frame}', setup: 'Editing the setup pose',
  },
  events: {
    title: 'Events', defaults: 'Default payload', int: 'Int', float: 'Float', string: 'String',
    keys: 'Keys in this animation', keyAt: 'Key at frame {frame}', keyRow: 'Frame {frame}',
  },
  skins: {
    title: 'Skins', default: 'default', duplicate: 'Duplicate', makeDefault: 'Make default', entries: 'Entries',
    slot: 'Slot', placeholder: 'Placeholder', attachment: 'Attachment', sameAsAttachment: '(attachment name)', addEntry: 'Add entry', remove: 'Remove',
  },
  drawOrder: {
    title: 'Draw Order', list: 'Slots, front first', forward: 'Bring forward', backward: 'Send backward', front: 'To front', back: 'To back',
    clearKey: 'Clear key here', keyed: 'Draw-order key at this frame',
  },
  constraints: {
    title: 'Constraints', endBone: 'End bone', chain: 'Chain', oneBone: '1 bone', twoBones: '2 bones', target: 'Target', create: 'Add IK',
    mix: 'Mix', softness: 'Softness', bendPositive: 'Bend positive', compress: 'Compress', stretch: 'Stretch', uniform: 'Uniform', order: 'Order',
    chainNote: '{bones} → {target}', keyedHere: 'Keyed here: {fields}',
  },
  sockets: {
    title: 'Sockets', parentBone: 'Parent bone', grip2: 'Second grip', create: 'Add socket', ax: 'Base x', ay: 'Base y', bx: 'Tip x', by: 'Tip y',
    items: 'Held items', item: 'Item', fitLength: 'Fit to grip length', equip: 'Equip', unequip: 'Unequip', noItems: 'No attachment with a handle',
  },
  directions: {
    title: 'Directions', none: 'No direction set yet.', create4: 'Create 4 directions', create8: 'Create 8 directions', count: 'Directions',
    layout: 'Layout', diagonal: 'Diagonal (NE, SE, SW, NW)', cardinal: 'Cardinal (N, E, S, W)', iso: 'Iso tile {w} × {h}', noIso: 'No iso tile',
    syncIso: 'Sync with grid', mode: 'Mode', authored: 'Authored', mirror: 'Mirror', mirrorFix: 'Mirror + fix', flipX: 'Flip X',
    mirrors: 'Mirrors {source}', asymmetry: 'Swaps sides when mirrored: {names}', useFix: 'Use mirror + fix', fixSkin: 'Fix skin', noChoice: '(none)',
    fixOps: 'Draw-order fixes', swap: 'Swap', moveAbove: 'Move above', moveBelow: 'Move below', addOp: 'Add fix', fixAnimations: 'Fix animations',
    opRow: '{op}: {a}, {b}',
  },
} as const;
